import React from 'react';
import styles from './landingFaq.module.css';

const FaqBackgroundText: React.FC<{ text: string }> = ({ text }) => (
  <p className={styles.backgroundText} aria-hidden="true">
    {text}
  </p>
);

export default FaqBackgroundText;
